import React from "react";
import { DarkTheme, LightTheme, ThemeProvider } from "baseui";
import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";
import { useLanguage } from "../../context/LanguageContext";
import translations from "../../i18n/translations";
import "./ExperienceAccordion.css";

function ExperienceAccordion(props) {
  const theme = props.theme;
  const { lang } = useLanguage();
  const tEntries = translations[lang].experience.entries;

  return (
    <div className="experience-accord">
      <ThemeProvider theme={theme.name === "light" ? LightTheme : DarkTheme}>
        <main className="experience-container experience-cards">
          {props.sections["experiences"].map((experience, index) => {
            const override = tEntries && tEntries[index];
            const localizedExp = override
              ? { ...experience, title: override.title, description: override.description }
              : experience;
            return (
              <ExperienceCard
                key={"experience-" + index}
                experience={localizedExp}
                theme={theme}
              />
            );
          })}
        </main>
      </ThemeProvider>
    </div>
  );
}

export default ExperienceAccordion;
